export default __webpack_public_path__ + "static/media/1271.0d3ecbef.jpeg";